// extracted by mini-css-extract-plugin
module.exports = {"partner":"N4JfZ","maskWrapper":"XnPTL","actions":"CSKPS","viewUserTimeSheet":"G0sZv","expandableCell":"kbA5N","threeDotsButton":"z4GER","participantsTable":"WAUUP"};